import React from "react";
import { Activity, HeartHandshake, Flower2, ArrowRight } from "lucide-react";
import { Card, CardHeader, CardTitle, CardContent, CardDescription, CardFooter } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const highlights = [{
  title: "Master Your Mindset",
  description: "Unlock the psychological frameworks used by the world's most successful entrepreneurs to overcome obstacles and achieve peak performance in every area of life.",
  icon: Activity,
  link: "/BlogPage"
}, {
  title: "Build Wealth Sustainably",
  description: "Discover proven investment strategies and financial systems designed to create long-term security and freedom for you and your family through market cycles.",
  icon: HeartHandshake,
  link: "/HomePage"
}, {
  title: "Strategic Business Growth",
  description: "Scale your impact with high-level consulting and tactical insights from over two decades of experience building multiple multi-million dollar brands.",
  icon: Flower2,
  link: "/ConsultingPage"
}];
export default function ServiceHighlights() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return;
}